export default [
	'bay-area-ca',
	'los-angeles-ca',
	'orange-county-ca',
	'san-diego-ca',
	'santa-barbara-ca',
];
